'use client';

import Link from 'next/link';

export default function PricingPage() {
  const leftFeatures = [
    'Unlimited payroll runs',
    'Statutory reports & filings',
    'Integrations included',
  ];
  const rightFeatures = [
    'Employee self-service portal',
    'Approval workflows',
    '24/7 customer support',
  ];

  return (
    <main>
      {/* ===== HERO TITLE BAND ===== */}
      <div
        style={{
          position: 'relative',
          marginTop: '0',
          background: '#db532a',
          overflow: 'hidden',
          paddingTop: '3.5rem',
          paddingBottom: '4.5rem',
        }}
      >
        <div className="container text-center px-4">
          <h1
            className="fw-bold text-white mb-2"
            style={{
              fontSize: 'clamp(2.4rem, 5.5vw, 3.5rem)',
              letterSpacing: '-0.025em',
            }}
          >
            Pricing
          </h1>
          <p
            className="text-white mb-0"
            style={{
              opacity: 0.95,
              fontSize: '1.08rem',
              fontWeight: 400,
            }}
          >
            Choose the right plan for your business
          </p>
        </div>
      </div>

      {/* ===== PRICING CONTENT SECTION ===== */}
      <section
        style={{
          backgroundColor: '#f7e1dd',
          paddingTop: '4.75rem',
          paddingBottom: '6.5rem',
        }}
      >
        {/* Section Header */}
        <div className="container text-center px-3" style={{ maxWidth: '680px' }}>
          <h2
            className="fw-bold"
            style={{
              fontSize: 'clamp(1.85rem, 3.8vw, 2.45rem)',
              color: '#111827',
              letterSpacing: '-0.03em',
              lineHeight: 1.25,
            }}
          >
            Simple pricing that scales with your team.
          </h2>
          <p
            style={{
              color: '#4b5563',
              fontSize: '0.96rem',
              lineHeight: 1.65,
              marginTop: '1.15rem',
              marginBottom: '2.5rem',
            }}
          >
            Pay only for the number of employees on your payroll — no bloated tiers, no hidden
            fees. Every plan includes unlimited access, detailed reports, structured dashboards
            and 24/7 customer support.
          </p>
        </div>

        {/* Pricing Card */}
        <div className="container px-3" style={{ maxWidth: '720px' }}>
          <div
            className="bg-white mx-auto"
            style={{
              borderRadius: '20px',
              boxShadow: '0 4px 25px rgba(0, 0, 0, 0.04)',
              padding: '2.75rem 3.25rem',
            }}
          >
            <p
              style={{
                fontSize: '0.8rem',
                fontWeight: 700,
                letterSpacing: '0.06em',
                color: '#4b5563',
                textTransform: 'uppercase',
                marginBottom: '0.65rem',
              }}
            >
              PER-EMPLOYEE PRICING
            </p>

            <div className="d-flex align-items-baseline gap-1 mb-2">
              <span
                style={{
                  fontSize: 'clamp(2.1rem, 4.5vw, 2.65rem)',
                  fontWeight: 800,
                  color: '#111827',
                  letterSpacing: '-0.02em',
                }}
              >
                Starts at ₦750
              </span>
              <span
                style={{
                  color: '#374151',
                  fontSize: 'clamp(1.1rem, 2.5vw, 1.35rem)',
                  fontWeight: 400,
                }}
              >
                /employee/month
              </span>
            </div>

            <p
              style={{
                color: '#374151',
                fontSize: '0.95rem',
                marginBottom: '2.25rem',
              }}
            >
              Volume discounts as your team grows. Nigeria &amp; Ghana included.
            </p>

            {/* Checklist Grid */}
            <div className="row g-3">
              <div className="col-12 col-sm-6">
                <ul className="list-unstyled mb-0 d-flex flex-column gap-3">
                  {leftFeatures.map((item) => (
                    <li key={item} className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center flex-shrink-0"
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          backgroundColor: '#c1402c',
                        }}
                      >
                        <i className="bi bi-check text-white" style={{ fontSize: '0.85rem' }}></i>
                      </span>
                      <span
                        style={{
                          fontSize: '0.92rem',
                          color: '#1f2937',
                          fontWeight: 500,
                        }}
                      >
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-12 col-sm-6">
                <ul className="list-unstyled mb-0 d-flex flex-column gap-3">
                  {rightFeatures.map((item) => (
                    <li key={item} className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center flex-shrink-0"
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          backgroundColor: '#c1402c',
                        }}
                      >
                        <i className="bi bi-check text-white" style={{ fontSize: '0.85rem' }}></i>
                      </span>
                      <span
                        style={{
                          fontSize: '0.92rem',
                          color: '#1f2937',
                          fontWeight: 500,
                        }}
                      >
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <div className="d-flex justify-content-center mt-4 pt-2">
            <Link
              href="/pricing/pricing-and-subscription/Get-started"
              className="text-decoration-none"
            >
              <button
                className="btn rounded-pill"
                style={{
                  border: '1.5px solid #d86f58',
                  color: '#c1402c',
                  backgroundColor: 'transparent',
                  padding: '0.7rem 2.25rem',
                  fontWeight: 600,
                  fontSize: '0.92rem',
                  transition: 'all 0.25s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#c1402c';
                  e.currentTarget.style.borderColor = '#c1402c';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.borderColor = '#d86f58';
                  e.currentTarget.style.color = '#c1402c';
                }}
              >
                View Pricing &amp; Plan
              </button>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}